import React, { useState } from "react";
import IDCard from "../CRM/IDcard/CampaignIDCard";
import CardRender from "../DashboardCardRender";
import NavBar from "../NavBar";
import WideCard from "../WideCard";
import "./HRPayroll.css";
import HRPayrollWindow, { hrPayrollCardData } from "./HRSideWindow";
import { HRWideCardData } from "../WideCardData"; 
import PayrollIdCard from './HRComponent/PayrollIdCard'
// import searchWhiteIcon from "../Icon.png";
export default function HRPayroll() {
  const [count, setCount] = useState([]);
  const [filtr1, setFiltr1] = useState("");
  const [filtr2, setFiltr2] = useState("");

  const handleFilter1 = (e) => {
    setFiltr1(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.pay < 30000
      } 
      else if (e.target.value === '2') {
        return x.pay < 50000
      }
      else if (e.target.value === '3') {
        return x.pay > 50000
      }
      else if (e.target.value === '4') {
        return x.pay > 100000
      }
    }));
  };

  const handleFilter2 = (e) => {
    setFiltr2(e.target.value);
    setCount(IncomingData.filter((x) => {
      if (e.target.value === '1'){
        return x.deptName === 'Marketing'
      } 
      else if (e.target.value === '2') {
        return x.deptName === 'Design'
      }
      else if (e.target.value === '3') {
        return x.deptName === 'Sales'
      }
      else if (e.target.value === '4')  {
        return (x.deptName !== 'Marketing' && x.deptName !== 'Design' && x.deptName !== 'Sales')

      }
    }));
    };
  return (
    <>
      <NavBar />
      <div>
        <p className="title">
          <span className="title_line"></span>
          <span className="account_title">Human Resource Management </span>
          <span className="color"> &#62; </span>
          <span className="color"> Payroll </span>
        </p>
      </div>
      <div id="Right-content-Down-First">
        <h2>Payroll</h2>
        <div id="Right-content-Down-Filters">
          <div
            style={{
              "border-left": "5px dotted rgba(0, 0, 0, 0.989)",
              height: "80%",
            }}
          ></div>
        </div>
      </div>
      <div id="OMS-main-content">
        <div className="hr-order-list-box" >
          <div id="click-data">
            <p>Active</p>
            <p>Resigned</p>
            <p>Terminated</p>
          </div>
          <div className="order-list-input-box" style={{width:"auto"}}>
            <div className="order-list-input-left" >
              <input
                placeholder="Enter ID Code or name to search..."
                type="text"
                onChange={(val) => {
                  setCount(
                    IncomingData.filter(
                      (x) =>
                        x.employeeId.match(val.target.value) ||
                        x.employeeName.match(val.target.value)
                    )
                  );
                  setFiltr1("");
                  setFiltr2("");
                }}
              />
              {/* <img src={searchWhiteIcon} alt="" width="" /> */}
            </div>
            <div className="order-list-input-right">

              <select name="" id="" className="order-list-input-right-filters"
               value={filtr1}
                onChange={handleFilter1}
              >
                <option selected>by pay</option>
                <option value="1">&lt;30000</option>
                <option value="2">&lt;50000</option>
                <option value="3">&gt;50000</option>
                <option value="4">&gt;100000</option>
              </select>
              
              <select name="" id="" className="order-list-input-right-filters"
               value={filtr2}
                onChange={handleFilter2}
              >
                <option value="" selected>
                  by department
                </option>
                <option value="1">Marketing</option>
                <option value="2">Design</option>
                <option value="3">Sales</option>
                <option value="4">other</option>
              </select>
            </div>
          </div>
          <table className="th-light" style={{ textAlign: "center" }}>
            <tr>
              <th>Employee ID</th>
              <th>Employee Name</th>
              <th>Department Name</th>
              <th>Pay</th>
              <th>Joined On</th>
              <th>Total Time</th>
            </tr>
            {count.length > 0
              ? count.map((val) => {
                  return (
                    <tr>
                      <td>{val.employeeId}</td>
                      <td>{val.employeeName}</td>
                      <td>{val.deptName}</td>
                      <td>{val.pay}</td>
                      <td>{val.joinedOn}</td>
                      <td>{val.totalTime}</td>
                    </tr>
                  );
                })
              : IncomingData.map((val) => {
                  return (
                    <tr>
                      <td>{val.employeeId}</td>
                      <td>{val.employeeName}</td>
                      <td>{val.deptName}</td>
                      <td>{val.pay}</td>
                      <td>{val.joinedOn}</td>
                      <td>{val.totalTime}</td>
                    </tr>
                  );
                })}
          </table>
        </div>
        {/* <HRPayrollWindow cardName={hrPayrollCardData} /> */}
        <div>
          
          <div style={{display:'flex',gap:"1rem",width:"30rem"}}>
              <CardRender comp={hrPayrollCardData} />
          </div>
            <WideCard data={HRWideCardData}/>
            <PayrollIdCard/>
            </div>
      </div>
    </>
  );
}
export const IncomingData = [
  {
    employeeId: "XAXDATS12233",
    employeeName: "Donald",
    deptName: "Marketing",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS9999",
    employeeName: "Ram",
    deptName: "Marketing",
    pay: 31000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 12000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 56000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Design",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Testing",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XAXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XDXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XCXDATS123DS",
    employeeName: "Sonu Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
  {
    employeeId: "XBXDATS125DS",
    employeeName: "John Doe",
    deptName: "Sales",
    pay: 120000,
    joinedOn: "28-06-2022",
    totalTime: "18 months",
  },
];
